import { Link } from 'react-router-dom';
import { entityDashboardRoutingSwitch } from 'features/navigation/routers/internal_routing';

function barchartCellProvider(entity: any, title: string) {
    const targetUrl =
        entity && entity.entityIdentifier
            ? entityDashboardRoutingSwitch(
                  entity.entityIdentifier.entityType,
                  entity.entityIdentifier
              )
            : null;
    return (
        <div className="overflow-x-hidden whitespace-nowrap text-ellipsis">
            {targetUrl ? (
                <Link
                    className="text-sky-600 hover:underline"
                    to={targetUrl}
                    target="_blank"
                    rel="noreferrer"
                >
                    {entity.entityIdentifier.entityName}
                </Link>
            ) : (
                title
            )}
        </div>
    );
}

export default barchartCellProvider;
